/*
 * @Author: Teemo Ding
 * @Date: 2021-09-23 13:57:43
 * @LastEditTime: 2022-06-01 18:03:49
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/index.tsx
 */

import { SizeFittingTable } from '@/src/components/Antd';
import { getDestinationLanguages } from '@/src/request/settings/logistics/destinationLanguages';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { columns } from './config';
import css from './css.module.less';

const permissions = () => {
  const view_destinationaddress_localisation_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory:
          EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
        operation: EnumOperation.view_all_logistics_settings_page,
      }),
    ],
  });
  const edit_destinationaddress_localisation_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory:
          EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
        operation: EnumOperation.edit_destinationaddress_localisation_setting,
      }),
    ],
  });
  return {
    view_destinationaddress_localisation_setting,
    edit_destinationaddress_localisation_setting,
  };
};

const DestinationAddressLocalisation = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const [list, setList] = useState([]);
  const {
    view_destinationaddress_localisation_setting,
    edit_destinationaddress_localisation_setting,
  } = permissions();

  const { loading } = useRequest(() => getDestinationLanguages(), {
    ready: !!view_destinationaddress_localisation_setting,
    onSuccess(result) {
      setList(result);
    },
  });

  const handleEdit = (record) => {
    const { countryCode, countryName } = record;
    history.push(
      `/settings/logistics/destinationLanguages/setting/${countryCode}/${countryName}`,
    );
  };

  return (
    <div>
      <Spin spinning={loading}>
        <SizeFittingTable
          id='ShippingZoneTable'
          rowKey='uuid'
          pagination={false}
          dataSource={list}
          className={css.shippingZoneTable}
          columns={columns(
            handleEdit,
            edit_destinationaddress_localisation_setting,
            { getI18n },
          )}
          scroll={{ y: 400 }}
          rowClassName={css.row}
        />
      </Spin>
    </div>
  );
};

export default DestinationAddressLocalisation;
